import { render } from "./TvmFlowNameIndicator.vue?vue&type=template&id=73b747a8&scoped=true"
import script from "./TvmFlowNameIndicator.vue?vue&type=script&lang=js"
export * from "./TvmFlowNameIndicator.vue?vue&type=script&lang=js"

import "./TvmFlowNameIndicator.vue?vue&type=style&index=0&id=73b747a8&lang=less&scoped=true"

import exportComponent from "../../../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b747a8"]])

export default __exports__